import { Component, OnInit } from '@angular/core';
import { CommonService } from '../_services';
import { Router } from '@angular/router';
import {ActivatedRoute} from '@angular/router';
import {environment} from '../../environments/environment';

@Component({
  selector: 'app-close-report',
  templateUrl: './close-report.component.html',
  styleUrls: ['./close-report.component.css']
})
export class CloseReportComponent implements OnInit {

  constructor(private activeroute: ActivatedRoute,private router: Router,
              private _service: CommonService) { }

  route:string;
  regionList = [];
  districtList = [];
  regionFilter = '';
  districtFilter   = '';
  countLoader = false;
  regionLoader = false;
  industryLoader = false;
  firstLevel:any = [];
  closeIndustryList = [];
  industryParameterList = [];
  selectedOfficerName = '';
  selectedRegionName = '';
  moreDetailDrilled = false;
  userData:any = [];
  public state: string = environment.state;

  userName;
  userLevel;
  searchField = {};


  ngOnInit() {

    this.userData = JSON.parse(localStorage.getItem('userData'));

    if(this.userData){
      this.userName = this.userData['user_profile_id'];
      this.userLevel = this.userData['access_level'];
    }

    if(this.userLevel == 'industry'){
      this.searchField['industryId'] = this.userName;
    }

    if(this.userLevel == 'vendor'){
      this.searchField['vendorId'] = this.userData['id']?this.userData['id']:'';
    }
    this.getRegionList();
    this.getDistrictList();
    this.getCloseIndustry();
  }


  getRegionList(){
    this.countLoader = true;
    this.route  = 'get-region-list';
    const token = localStorage.getItem('userToken');

    let data = [];

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }
      if(response.status == 200){
        this.regionList = response.data;
      }
    });
  }

  getDistrictList(){
    this.countLoader = true;
    this.route  = 'get-all-city-list';
    const token = localStorage.getItem('userToken');

    let data = [];

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }
      if(response.status == 200){
        this.districtList = response.data;
      }
    });
  }

  getCloseIndustryList(regionName,officerName){

    this.industryLoader = true;
    this.moreDetailDrilled = false;
    this.selectedRegionName = regionName;
    this.selectedOfficerName = officerName;

    this.route  = 'get-close_industry-list';
    const token = localStorage.getItem('userToken');

    let data = {'region_name':regionName};

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
        // location.reload();
      }
      if(response.status == 200){
        this.closeIndustryList = response.data;
        this.industryParameterList = response.parameter;
      }
      this.industryLoader = false;
    });
  }

  getCloseIndustry(){

    this.regionLoader = true;
    this.route  = 'get-report-close_industry';
    const token = localStorage.getItem('userToken');

    let data = {'region':this.regionFilter,'district':this.districtFilter, 'search_fields': this.searchField};

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
        // location.reload();
      }
      if(response.status == 200){


        if(response.result.length != 0){
          this.firstLevel = response.result;
        }else{
          this.firstLevel = false;
        }

      }
      this.regionLoader = false;
    });
  }

}
